// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_sync_run".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "meta_sync_run" table (1:1 with a DB row, on the wire). */
export const metaSyncRunAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    trigger: z.enum(['manual', 'scheduled', 'webhook']),
    status: z.enum(['running', 'succeeded', 'partial', 'failed', 'skipped']),
    startedAt: z.string().datetime(),
    finishedAt: z.string().datetime().nullable(),
    summary: z.unknown().nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
});
//# sourceMappingURL=metaSyncRun.js.map